import React, { useEffect, useState } from "react";
import CustomerDetails from "../components/CustomerDetails";
import CustomerList from "../components/CustomerList";
import Card from "../ui/Card";
import Nav from "../ui/Nav";
import Space from "../ui/Space";
import { pubCall } from "../utils/PubSub";
import { ROUTES } from "../utils/Routes";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import { showError } from "../ui/Message";
import CustomerHistory from "../components/CustomerHistory";
import CustomersSearch from "../popups/CustomersSearch";
import { createModal } from "../hooks/createModal";
import Checkbox from "../ui/Checkbox";
import Tabs from "../ui/Tabs";
import { ENUMS } from "../utils/Enums";
import { drawPicker } from "../popovers/Picker";
import CustomerAR from "../components/CustomerAR";

export default function CustomersController(props) {

    const { controller = "", is_modal = false, signal = {}, search = "", callback = () => { }, setController = () => { } } = props;
    //ship_to is the unique id
    const [selected, setSelected] = useState({});
    const [filters, setFilters] = useState({ limit: 40, sort: "name", dynamic: (is_modal) ? false : true }) // bill_to, name, san, ship_to
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [align, setAlign] = useState("auto");

    const [state, setState] = useState({
        view: "customers",
        search: "",
        tabs: "history",
        history_checked: false,
    })

    const route = ROUTES.CUSTOMER.CUSTOMER;

    const searchCustomer = () => {

        if (!is_modal) {
            return;
        }
        setLoading(true);
        pubCall("customer.searchNamePhoneAccount", { search_term: search, limit: 45 }, (_s, _r) => {
            if (_s) {

                setData(_r.rows);
                if (_r?.rows?.length > 0) {
                    setSelected(_r.rows[0]);
                }
            }
            setLoading(false)
        })
    }

    useEffect(searchCustomer, []);



    const drawIndex = () => {
        drawPicker({
            controller : controller,
            value: filters.sort, title: "Index", closeable: true, height: 300, ref: null, route: route, close: () => { }, callback: (e) => {
                setFilters({ ...filters, "sort": e });
            }, offset: [0, 10],
            options: ENUMS.CUSTOMERS_SORT
        })
    }

    const customers_nav = [
        { key: KBD.Digit2, action : () => setController("inventory") },
        { key: KBD.A, text: "A/R", action: () => { switchView("ar") } },
        { text: "Copy" },
        { text: "Ctrl+Copy", inds: [0, 1, 2, 3, 4, 5] },
        { text: "Delete" },
        { text: "Edit" },
        { text: "Filter" },
        { text: "History" },
        { key: KBD.I, text: "Index", action: drawIndex },
        { text: "Kard" },
        { text: "Label" },
        { text: "Message" },
        { text: "New" },
        { text: "Print" },
        { key: KBD.S, text: "Search", action: () => showSearch() },
        { text: "View" },
        { text: "Xtra" },
        { key: KBD.ARROW_RIGHT, action: () => switchView("history") },
        { key: KBD.ESCAPE, action: () => { (is_modal) ? callback() : setController("home") } },
        {
            key: KBD.ENTER, action: () => {
                if (is_modal) {
                    callback(selected)
                }
            }
        }

    ]

    useEffect(() => {
        const cleanup = listen(controller, route, customers_nav);
        return cleanup;
    }, [selected])

    useEffect(() => { window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER }, []);


    const CustomerNotes = (props) => {

        const { note = "" } = props.selected;

        return (
            <Card secondary header={<Label style={{ "textAlign": "left" }}>Customer Notes</Label>}>
                <div style={{ "height": "calc(100vh - 470px)", "width": "277px", "display": "flex", "alignItems": "center", "justifyContent": "center" }}>
                    <div style={{ "width": "150px", "height": "100px" }}>
                        <Label style={{ "textAlign": "center" }}>
                            {(note && note)}
                            {(!note && <em>Press <strong><u><span style={{ "fontStyle": "normal", "fontWeight": "800", "color": "var(--text-light)" }}>M</span></u></strong>essage to add longform notes.</em>)}
                        </Label>
                    </div>
                </div>
            </Card>
        )
    }

    const showSearch = () => {
        window.bm_state.value = ROUTES.CUSTOMER.SEARCH;
        createModal({
            component: <CustomersSearch state={state} setState={setState} signal={signal} setStock={setSelected} selected={selected} route={ROUTES.CUSTOMER.SEARCH} />, closable: true, title: "Customer Search",
            callback: (_r) => {
                if (_r) {
                    setAlign("start");
                    if (_r.dynamic) {
                        setFilters({ ...filters, "dynamic": true })
                        setData(_r.results.rows_previous.concat(_r.results.rows_next));
                        setSelected((_r.results.rows_next.length > 0) ? _r.results.rows_next[0] : {})
                    } else {
                        setFilters({ ...filters, "dynamic": false })
                        setData(_r.results.rows);
                        if (_r.results?.rows?.length > 0) {
                            setSelected(_r.results.rows[0]);
                        }
                    }
                }
                window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER
            }
        });
    }

    const switchView = (_state = "customers") => {


        let _tab = state.tabs;

        switch (_state) {
            case "customers":
                window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
                break;
            case "history":
                _tab = "history";
                window.bm_state.value = ROUTES.CUSTOMER.HISTORY;
                break;
            case "ar":
                window.bm_state.value = ROUTES.CUSTOMER.AR;
                break;
        }

        setState({ ...state, "view": _state, "tabs": _tab })
    };


    const toggleHistory = () => {
        setState(prev => ({
            ...prev,
            history_checked: !prev.history_checked
        }));
    };

    const handleTabChange = (tabId) => {
        let _view = state.view;
        if (tabId === "notes" && window.bm_state.value === ROUTES.CUSTOMER.HISTORY) {
            setState(prev => ({ ...prev, tabs: "notes", view: "customers" }));
            window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        }
        else {
            setState(prev => ({ ...prev, tabs: tabId, view: _view }));
        }


    };





    const tabData = [
        { id: "history", label: <><Checkbox value={state.history_checked} onChange={toggleHistory}>&nbsp;</Checkbox>History</>, content: <></> },
        { id: "notes", label: <>Notes</>, content: <></> },
    ];


    const drawExtra = () => {


        if (state.view === "reserve") {
            return (<></>)
        }

        const { tabs, history_checked } = state;

        const _history = <CustomerHistory controller={controller} view={state.view} route={ROUTES.CUSTOMER.HISTORY} switchView={switchView} selected={selected} />;
        // Determine what goes in the right panel
        let rightContent = null;
        if (tabs === "history") {
            rightContent = _history;
        } else if (tabs === "notes") {
            rightContent = <><CustomerNotes selected={selected} /></>;
        } else if (tabs === "peers") {
            rightContent = <>Peers</>;
        }

        const showLeftHistory = tabs !== "history" && history_checked;


        return (
            <Space
                grow
                style={{ alignItems: "flex-start", padding: "0px 0px" }}
                size={0}
            >
                {(showLeftHistory) && <div style={{ flex: 1, "marginRight": "15px" }}>
                    {showLeftHistory ? _history : null}
                </div>}

                <div style={{ flex: 3 }}>
                    <Tabs
                        selected={state.tabs}
                        onChange={handleTabChange}
                        show_content={false}
                        indent
                        style={{ marginTop: "-22px" }}
                        content_class=""
                        border={false}
                        tabData={tabData}
                    />
                    {rightContent}
                </div>
            </Space>
        )
    }

    const filterLocal = (_data, _filters = filters) => {

        if (_filters.dynamic) {
            return _data;
        } else {
            let _s = _filters.localSort;
            return _data.sort((a, b) => {
                if (a[_s] < b[_s]) {
                    return -1;
                }
                if (a[_s] > b[_s]) {
                    return 1;
                }
                return 0;
            })
        }
    }



    return (<>


        <div className="controller">
            <CustomerDetails
                controller={controller}
                selected={selected}
                setSelected={setSelected}
                route={ROUTES.CUSTOMER.DETAILS}
            // state={state}
            // setState={setState}

            // signal={signal}
            // in_stock={in_stock}
            // setData={setData}
            // isTitleLink={isTitleLink}
            // updateRow={updateRow}
            // switchEdit={switchEdit}
            // isnew={state.new}
            // edit={state.edit}
            // stock_data={getStockData()}
            />
            <div>
                <div>
                    <div className="shim" />


                    {/* const {data = [], selected = {}, setSelected = () => { }, loading = false, setLoading = () => { }, align = "auto", setAlign = () => { }, route = ""} = props; */}

                   
                    {(state.view === "ar" && <>
                           <CustomerAR controller={controller} switchView={switchView} selected={selected} drawExtra={drawExtra} route={ROUTES.CUSTOMER.AR} />
                    </>)}

                    {((state.view === "customers" || state.view === "history") &&
                        <>
                            <Space style={{ "padding": "5px 20px" }}>
                                <Label>{state.search}&nbsp;</Label>
                            </Space>

                            <Space grow style={{ "alignItems": "flex-start", "padding": "0px 15px" }} size={15}>
                                <CustomerList
                                    controller={controller}
                                    filterLocal={filterLocal}
                                    signal={signal}
                                    view={state.view}
                                    align={align}
                                    setAlign={setAlign}
                                    selected={selected}
                                    setSelected={setSelected}
                                    loading={loading}
                                    setLoading={setLoading}
                                    data={data}
                                    setData={setData}
                                    filters={filters}
                                    setFilters={setFilters}
                                    route={route}
                                    state={state}
                                />
                                {drawExtra()}
                            </Space>
                        </>
                    )}


                </div>
            </div>
            <div className="shim" />
            <Divider />
            <div style={{ 'height': "30px" }}>
                {(state.view === "customers" &&
                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={customers_nav} />
                    </Space>
                )}
            </div>
        </div>


    </>)

}


